module.exports = "/foodslaboEf/img/step12/search.svg";